export * from './climate-action-workforce';
export * from './subscriptions';

export enum SubscriptionStatus {
  // Has been paid and is currently Active
  Active = 'Active',
  // Has been created, but yet to receive first payment
  Incomplete = 'Incomplete',
  // Soft-deletion
  Deleted = 'Deleted',
  // Payment has failed and is being automatically retired
  FailingPayment = 'FailingPayment',
  // Existing but un-wired to any ProcessorSubscription
  Paused = 'Paused',
}
